import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="min-h-screen w-full bg-cream flex items-center justify-center px-4 py-16 md:py-20" data-id="element-27">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-28">
        {/* Left: Headline + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left" data-id="element-29">
          <motion.h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-brown mb-6 leading-tight" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-30">
            ¿Y si el pan que te prohibieron fuera la forma más rica de cuidarte?
          </motion.h1>

          <motion.p className="font-body text-lg md:text-xl text-brown/80 mb-8 max-w-2xl mx-auto lg:mx-0" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-31">
            Panadería sin TACC • Sin Azúcar • Con sabor real
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} data-id="element-32">
            <Button size="lg" onClick={scrollToOffer} className="w-full sm:w-auto" data-id="element-33">
              Quiero el Ebook Ahora
            </Button>
          </motion.div>
        </motion.div>

        {/* Right: Hero Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="relative" data-id="element-34">
          <img src="https://cdn.magicpatterns.com/uploads/fcu9dmwbeZi1MvpgFpjUw3/martina_con_ebok.png" alt="Chef Martina Guez sosteniendo el ebook Panadería sin Culpa en tablet y teléfono" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-35" />
        </motion.div>
      </div>
    </section>;
}